import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { AuthGuard } from "../components/AuthGuard";
import { AuthProvider } from "../components/AuthProvider";
import { BillingContextSwitcher } from "../components/BillingContextSwitcher";
import { MobileTakeover } from "../components/MobileTakeover";
import { WelcomeVideoGate } from "../components/WelcomeVideoGate";
import { useIsMobile } from "../hooks/useIsMobile";
import { isMobileAllowedPath } from "../lib/mobile-access";

function RootLayout() {
  const isMobile = useIsMobile();
  const pathname = useLocation({ select: (location) => location.pathname });
  if (isMobile && !isMobileAllowedPath(pathname)) return <MobileTakeover />;

  return (
    <>
      <AuthProvider>
        <BillingContextSwitcher />
        <AuthGuard>
          <WelcomeVideoGate />
          <Outlet />
        </AuthGuard>
      </AuthProvider>
      <TanStackRouterDevtools />
    </>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: () => (
    <div className="flex items-center justify-center min-h-screen bg-[var(--bg-default)]">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-[var(--text-primary)] mb-4">
          404
        </h1>
        <p className="text-[var(--text-secondary)] mb-4">Page not found</p>
        <a
          href="/"
          className="text-[var(--accent-secondary-hover)] hover:text-[var(--accent-secondary-hover-stroke)]"
        >
          Go home
        </a>
      </div>
    </div>
  ),
});
